
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.76 17.02"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.853 0A3.69 3.69 0 019.06 7.177l-.187.06v5.383h2.76c.112 0 .207.075.235.178l.009.065v.64c0 .1.067.184.159.209l.057.007h3.334c.16 0 .295.115.326.267l.007.067v2.633a.334.334 0 01-.266.327l-.067.006H.333a.334.334 0 01-.326-.266L0 16.686v-2.633c0-.161.114-.296.266-.327l.067-.007H3.65a.227.227 0 00.215-.167l.008-.06v-.63a.247.247 0 01.182-.234l.065-.009h2.713V7.236A3.69 3.69 0 017.853 0zM2.3 12.62a.34.34 0 01.34.34v.146a.34.34 0 01-.34.34H1.133a.34.34 0 01-.34-.34v-.146a.34.34 0 01.34-.34H2.3z"}})])
          )
        }
      }
    